class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.onEscape = (event) => {
      if (event.key !== 'Escape' || !this.classList.contains('active') || document.querySelector('dialog[open]')) return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
    };
    this.addEventListener('click', (event) => {
      if (event.target.id === 'CartDrawer-Overlay') this.close();
    });
    this.revision = 0;
    this.inner = this.querySelector('.drawer__inner');
    this.observer = new MutationObserver(() => {
      const inner = this.querySelector('.drawer__inner');
      const replaced = inner !== this.inner;
      this.inner = inner;
      this.syncState();
      if (replaced) this.refreshFocus();
    });
    this.observer.observe(this, { childList: true, subtree: true });
    this.syncState();
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    document.addEventListener('keydown', this.onEscape, true);
    this.observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onEscape, true);
    this.observer.disconnect();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.syncState();
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    this.addEventListener('transitionend', () => this.refreshFocus(), { once: true });
    requestAnimationFrame(() => requestAnimationFrame(() => this.refreshFocus()));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  syncState() {
    const empty = Boolean(this.querySelector('.drawer__inner-empty'));
    this.classList.toggle('is-empty', empty);
    if (empty) {
      const scroller = this.querySelector('.careiz-drawer-scroll');
      if (scroller) scroller.scrollTop = 0;
    }
  }

  refreshFocus(preferredId) {
    if (!this.classList.contains('active') || document.querySelector('dialog[open]')) return;
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;
    const preferred = preferredId && document.getElementById(preferredId);
    const focused = inner.contains(document.activeElement) ? document.activeElement : null;
    trapFocus(inner, (preferred && inner.contains(preferred) && preferred) || focused || inner.querySelector('.drawer__header .drawer__close') || inner);
  }

  updateContents(html) {
    if (!html) return false;
    const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    const target = this.querySelector('.drawer__inner');
    if (!source || !target) return false;
    const focusedId = target.contains(document.activeElement) ? document.activeElement.id : '';
    const scrollTop = target.querySelector('.careiz-drawer-scroll')?.scrollTop || 0;
    this.revision += 1;
    target.replaceWith(source);
    this.inner = source;
    this.syncState();
    const scroller = source.querySelector('.careiz-drawer-scroll');
    if (scroller && !this.classList.contains('is-empty')) scroller.scrollTop = scrollTop;
    this.refreshFocus(focusedId);
    return true;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections?.[section.id];
      if (!html) return;
      if (section.id === 'cart-drawer') {
        this.updateContents(html);
        return;
      }
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
    });

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
